import { Consultation } from 'types';
const ARCHIVED_STATUSES = ['Determined', 'Withdrawn', 'Closed'];
export const useCanAddNote = (consultation?: Consultation): boolean => {
  if (
    typeof consultation !== 'undefined' &&
    consultation !== null &&
    Object.keys(consultation).length > 0
  ) {
    const { status, isArchived } = consultation || {};
    // Hide if a consultation is archived and withdrawn, closed or determined.
    return !(isArchived && status && ARCHIVED_STATUSES.includes(consultation.status));
  }
  return false;
};
